import React from "react";
import Marquee from "react-fast-marquee";
import "./marquee.css";

export default function MarqueeBanner() {
  return (
    <div className="marquee">
      <Marquee speed={80} direction="right">
        <span>FREE 4-HOUR VPK — WITH AN EXCLUSIVE FINAL HOUR FOCUSED ON EARLY READING SKILLS • ONLY AVAILABLE HERE!</span>
      </Marquee>
    </div>
  );
}
